import { ViewProduct } from '../../../../pages/admin-dashboard/products/admin-products.model';
import { ProductListTableRow } from './admin-list-view.model';

const NO_VALUE = 'ـــ';

function formatPrice(price: number | null | undefined, isArabic: boolean): string {
  return price ? `${price} ${isArabic ? 'ج.م' : 'EGP'}` : NO_VALUE;
}

function formatPriceWithDiscount(price: number, discountPercentage: number | null | undefined, isArabic: boolean) {
  return {
    price: formatPrice(price, isArabic),
    discount: discountPercentage ? `${discountPercentage}%` : '',
  };
}

function toProductListTableRow(
  product: ViewProduct,
  isArabic: boolean,
  hasSubproducts: boolean | '',
  isActive: boolean,
): ProductListTableRow {
  // Quantities are only meaningful when sub-products are not filtered on.
  const showQuantity = hasSubproducts === false || typeof hasSubproducts === 'string';

  return {
    id: product.id,
    title: (isArabic ? product.titleAr : product.titleEn) || product.titleEn,
    mfgCompany: (isArabic ? product.mfgCompany?.titleAr : product.mfgCompany?.titleEn) ?? NO_VALUE,
    customerPrice: formatPrice(product.customerPrice, isArabic),
    sellerPrice: formatPriceWithDiscount(product.sellerPrice, product.sellerPriceDiscountPercentage, isArabic),
    businessPrice: formatPriceWithDiscount(product.businessPrice, product.businessPriceDiscountPercentage, isArabic),
    quantity: showQuantity ? `${product.totalQuantity} / ${product.availableQuantity}` : NO_VALUE,
    createdOn: product.createdOn,
    createdBy: product.createdBy?.fullName ?? '___',
    lastModifiedOn: product.lastModifiedOn ?? null,
    lastModifiedBy: product.lastModifiedBy?.fullName ?? null,
    activationStatus: isActive ? { titleEn: 'Active', titleAr: 'نشط' } : { titleEn: 'Inactive', titleAr: 'غير نشط' },
  };
}

export function toProductListTableRows(
  products: ViewProduct[],
  isArabic: boolean,
  hasSubproducts: boolean | '',
  isActive: (productId: number) => boolean,
): ProductListTableRow[] {
  return products.map((p) => toProductListTableRow(p, isArabic, hasSubproducts, isActive(p.id)));
}
